import React from 'react';
import classNames from 'classnames';
import styles from './IconListItem.module.scss';
import { Icon, IconProps } from 'ui/components/1-atoms/Media/Icon';
import RoundCheckMarkIcon from 'ui/icons/icon-round-checkmark-web.svg';

export interface IconListItemProps {
	className?: string;
	text?: string;
	iconSize?: IconProps['size'];
}

export const IconListItem: React.FC<IconListItemProps> = ({ className, text, iconSize = 'lg' }) => {
	return (
		<li className={classNames(styles.IconListItem, className)}>
			<Icon className={classNames(styles.IconListItem_icon, styles.IconListItem_icon___primary)} size={iconSize}>
				<RoundCheckMarkIcon />
			</Icon>
			<span className={styles.IconListItem_text}>{text}</span>
		</li>
	);
};
